import league from '../api/league.api'
// each Vuex instance is just a single state tree.
const state = {
  clubList: [],
  selectedLeague: null,
  leagueList: null
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  refreshClubList (state, AllClubs) {
    state.clubList = AllClubs
  },
  selectLeague (state, leagueToSelect) {
    state.selectedLeague = leagueToSelect
  },
  unselectLeague (state) {
    state.selectedLeague = null
  },
  refreshLeagueList (state, AllLeagues) {
    state.leagueList = AllLeagues
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  getClubList (context) {
    league.api.getClubList()
      .then(response => {
        context.commit('refreshClubList', response.data)
      },
      error => {
        console.log('impossible to load match report list from api: ')
        console.log(error)
      })
  },
  activateLeague (context, leagueId) {
    context.commit('selectLeague', leagueId)
  },
  deactivateLeague (context) {
    context.commit('unselectLeague')
  },
  getLeagueList (context) {
    league.api.getLeagueList()
      .then(response => {
        context.commit('refreshLeagueList', response.data)
      },
      error => {
        console.log('impossible to load league list from api: ')
        console.log(error)
      })
  }
}

// getters are functions
const getters = {
  activatedLeague: state => {
    return state.selectedLeague
  },
  activatedClub: state => {
    if (state.selectedLeague === null) {
      return null
    }
    return state.clubList.find(c => { return c.leagues.find(l => { return l.id === state.selectedLeague }) })
  },
  activatedRankingGroups: state => {
    if (state.selectedLeague === null) {
      return null
    }
    let filteredClub = state.clubList.find(c => { return c.leagues.find(l => { return l.id === state.selectedLeague }) })
    let rg = []
    filteredClub.leagues[0].ranking_groups.forEach(group => {
      rg.push(group.id)
    })
    return rg
  },
  clubList: state => {
    return state.clubList
  },
  leagueNameList: state => {
    let nameList = []
    if (state.leagueList === null) {
      return []
    }
    state.leagueList.forEach(league => {
      let foundIndex = nameList.findIndex(name => {
        return name === league.name
      })
      if (foundIndex === -1) {
        nameList.push(league.name)
      }
    })
    return nameList
  },
  formatedClubList: state => {
    let clubList = []
    state.clubList.forEach(club => {
      let clubObject = {}
      clubObject.id = club.id
      clubObject.name = club.name
      let leagueList = []
      club.leagues.forEach(league => {
        let foundLeague = leagueList.find(l => {
          return l.name === league.name
        })
        if (foundLeague !== undefined) {
          let seasonObject = {}
          seasonObject.id = league.id
          seasonObject.name = league.season
          seasonObject.ranking_groups = league.ranking_groups
          seasonObject.starting_rules = league.starting_rules
          foundLeague.seasons.push(seasonObject)
        } else {
          let leagueObject = {}
          let seasonObject = {}
          let seasonList = []
          leagueObject.name = league.name
          seasonObject.id = league.id
          seasonObject.name = league.season
          seasonObject.ranking_groups = league.ranking_groups
          seasonObject.starting_rules = league.starting_rules
          seasonList.push(seasonObject)
          leagueObject.seasons = seasonList
          leagueList.push(leagueObject)
        }
      })
      clubObject.leagues = leagueList
      clubList.push(clubObject)
    })
    return clubList
  },
  leagueListForClub: (state, getters) => clubId => {
    return getters.formatedClubList.find(club => { return club.id === clubId }).leagues
  },
  leagueListForActivatedClub: (state, getters) => {
    if (getters.activatedClub) {
      return getters.formatedClubList.find(club => {
        return club.id === getters.activatedClub.id
      }).leagues
    }
    return []
  },
  seasonListForLeague: state => seasonId => {
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/league.js